import styled from 'styled-components';

const AvatarGroup = styled.div`
  position: relative;
  height: 100%;
`;

/** @component */
export default AvatarGroup;
